import { httpClient } from '../client';
import {
  ChatHistoryResponse,
  ChatLogsT,
  updateChatLogDTO,
  ChatLogsResponse,
} from '../../../types/chat';
import { logger } from '../../../utils/logger';
import { BaseEndpoint } from './base.endpoint';
import { ApiErrorHandler } from '../error.handler';

class ChatEndpoints extends BaseEndpoint {
  private static instance: ChatEndpoints;

  private constructor() {
    super('chat');
  }

  static getInstance(): ChatEndpoints {
    if (!ChatEndpoints.instance) {
      ChatEndpoints.instance = new ChatEndpoints();
    }
    return ChatEndpoints.instance;
  }

  async getChatHistory(organizationId: string, connectionId: string) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<ChatHistoryResponse>(
        `${this.basePath}/${organizationId}/history/${connectionId}`,
        { headers }
      );

      logger.info('Chat history fetched successfully');
      return response.data.data;
    } catch (error) {
      logger.error('Failed to fetch chat history:', error);
      return [];
    }
  }

  async getChatLogs(organizationId: string | null) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<ChatLogsResponse>(
        `${this.basePath}/${organizationId}/history`,
        { headers }
      );

      logger.info('Chat logs fetched successfully');
      return response.data.data;
    } catch (error) {
      logger.error('Failed to fetch chat logs:', error);
      return [];
    }
  }

  async updateChatLog(
    organizationId: string | null,
    connectionId: string,
    data: updateChatLogDTO
  ): Promise<ChatLogsT> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.put<{ data: ChatLogsT }>(
        `${this.basePath}/${organizationId}/history/${connectionId}`,
        data,
        { headers }
      );

      logger.info('Chat log updated successfully');
      return response.data.data;
    } catch (error) {
      logger.error('Failed to update Chat log:', error);
      return ApiErrorHandler.handle(error);
    }
  }
}

export const chatEndpoints = ChatEndpoints.getInstance();
